import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPromotionAnalytics } from '../../services'
import { DashboardKeys } from '@/modules/dashboard/keys'
import {
	GetPromotionAnalyticsResponse,
	GetPromotionAnalyticsRequest,
} from '@/modules/dashboard/type'

export default function useQueryGetPromotionAnalytics(
	payload: GetPromotionAnalyticsRequest,
	props?: UseBaseQueryOptions<GetPromotionAnalyticsResponse>,
) {
	return useQuery({
		queryKey: [DashboardKeys.PromotionAnalytics, payload],
		queryFn: () => getPromotionAnalytics(payload),
		...props,
	})
}
